import { MiniMap, MiniMapNodeProps } from '@xyflow/react'
import React, { memo, useCallback } from 'react'
import { nodeColor } from '@/constants/nodeTypes'

interface FlowMiniMapProps {
  showMap: boolean
  setShowNodeIndex: (value: boolean) => void
  handleNodeSelect: (nodeId: string) => void
}

const FlowMiniMap: React.FC<FlowMiniMapProps> = ({
  showMap,
  setShowNodeIndex,
  handleNodeSelect,
}) => {
  const MiniMapNode = useCallback(
    (props: MiniMapNodeProps) => {
      // Ensure coordinates are valid numbers
      const safeCoords = {
        x: Number.isFinite(props.x) ? props.x : 0,
        y: Number.isFinite(props.y) ? props.y : 0,
        width: Number.isFinite(props.width) ? props.width : 10,
        height: Number.isFinite(props.height) ? props.height : 10,
      }

      return (
        <rect
          {...safeCoords}
          fill={props.color || '#eee'}
          stroke={props.strokeColor || '#ddd'}
          strokeWidth={props.strokeWidth || 1}
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            if (props.id) {
              requestAnimationFrame(() => handleNodeSelect(props.id))
            }
          }}
        />
      )
    },
    [handleNodeSelect]
  )

  return (
    <MiniMap
      nodeStrokeWidth={3}
      nodeComponent={MiniMapNode}
      pannable
      zoomable={false}
      nodeColor={nodeColor}
      style={{
        display: showMap ? 'block' : 'none',
        position: 'absolute',
        bottom: '0px',
        right: '0px',
        background: 'rgba(255, 255, 255, 0.05)',
        border: '1px solid rgba(100, 100, 255, 0.3)',
        borderRadius: '4px',
      }}
    />
  )
}

export default memo(FlowMiniMap)
